import classNames from 'classnames';
import React from 'react';
import { pickDomAttrs } from '../../_util/utils';
import Tooltip from '../../tooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const NameIdSpace = props => {
  const {
    name,
    id,
    style,
    isEditStyle = false,
    isLinkStyle = false,
    ellipsis,
    disabled,
    disabledTip,
    ...restProps
  } = props;
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    title: !!disabled && disabledTip,
    getPopupContainer: t => t.parentElement,
    children: /*#__PURE__*/_jsxs("div", {
      ...attrs.data,
      className: classNames('nameIdSpace-wrap', {
        ellipsis,
        isEditStyle,
        isLinkStyle,
        disabled
      }),
      style: style,
      children: [name && /*#__PURE__*/_jsx("span", {
        className: "name",
        children: name
      }), id && /*#__PURE__*/_jsx("span", {
        className: "id",
        children: id
      })]
    })
  });
};